<template>
  <a-modal
    width="1200px"
    v-model="isShow"
    centered
    :mask-closable="false"
    :body-style="{ paddingLeft: 0 }"
    title="eSIM详情"
  >
    <a-row type="flex" :gutter="24">
      <a-col flex="200px">
        <a-menu
          class="left-menus"
          mode="vertical"
          :default-selected-keys="['ShowEsimBaseInfo']"
          @select="handleSelectMenu"
        >
          <a-menu-item
            v-for="item in tabs"
            :key="item.component"
          >
            <a-icon :type="item.icon" />
            {{ item.name }}
          </a-menu-item>
        </a-menu>
      </a-col>
      <a-col flex="1000px" class="right-content">
        <keep-alive>
          <component
            :is="currentComponent"
            :id="id"
          />
        </keep-alive>
      </a-col>
    </a-row>
    <template slot="footer">
      <a-button
        class="ant-btn-primary"
        @click="updateEimData"
        :loading="isUpdateBtnLoading"
      >
        更新
      </a-button>
      <a-button class="ant-btn-primary" @click="closeModal">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
import { updateEsimEimData } from '@/api/esim'

export default {
  name: 'ShowEsim',
  components: {
    ShowEsimBaseInfo: () => import('@/views/esims/info/BaseInfo'),
    ShowEsimProfileList: () => import('@/views/esims/info/ProfileList'),
    ShowEsimOperationRecords: () => import('@/views/esims/info/OperationRecords')
  },
  props: {
    visible: { type: Boolean, required: true },
    id: { type: Number, required: true }
  },
  data() {
    return {
      currentComponent: 'ShowEsimBaseInfo',
      isUpdateBtnLoading: false,
      tabs: [
        { component: 'ShowEsimBaseInfo', name: '基本信息', icon: 'profile' },
        { component: 'ShowEsimProfileList', name: 'Profile 列表', icon: 'unordered-list' },
        { component: 'ShowEsimOperationRecords', name: '操作记录', icon: 'history' }
      ]
    }
  },
  computed: {
    isShow: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  methods: {
    handleSelectMenu({ key }) {
      this.currentComponent = key
    },
    updateEimData() {
      this.isUpdateBtnLoading = true
      updateEsimEimData(this.id).then(() => {
        this.isUpdateBtnLoading = false
      }).catch(() => {
        this.isUpdateBtnLoading = false
      })
    },
    closeModal() {
      this.isShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.left-menus {
  height: 100%;
}
.right-content {
  height: 500px;
  overflow: auto;
}
</style>
